import React, { Component } from 'react';
import { connect } from 'react-redux';
import { login } from '../../actions/sessions';
import { Link } from 'react-router-dom';
import { Field, reduxForm } from 'redux-form';
import MemberService from '../../services/memberService';
import CONSTANTS from '../../constants'

class Login extends Component {

	constructor(props) {
		MemberService.logout();
		super(props);
		const bname = props.match.params.bname;
		this.state = {
			bname: bname,
			email: '',
			password: '',
			submitted: false
		};
	}


	renderField(field) {
		let hasError = field.meta.touched && field.meta.error;
		return (
			<div className="form-group">
				<div className="input-group">
					<span className="input-group-addon is-invalid"><i className={field.icon}></i></span>
					<input {...field.input}  className={`form-control ${hasError ? 'is-invalid' : ''}`} type={field.type}
					                         placeholder={field.placeholder} />
				</div>
				<div className="invalid-feedback">
					{ hasError ? field.meta.error : ''}
				</div>
			</div>
		)
	}

	onSubmit(values) {
		this.props.login(this.state.bname, values.email, values.password, this.props.history);
	}

	render () {
		const { handleSubmit } = this.props;
		return (
			<div className="flex-center">
				<div className="content-card col-lg-6 col-xs-12">
					<h1>{CONSTANTS.APP_TITLE}</h1>
					<p className="text-muted">Sign In to your account</p>
					<form className="members-area-form" onSubmit={handleSubmit(this.onSubmit.bind(this))}>

						<Field
							name="email"
							type="email"
							placeholder="Email"
							className="form-control"
							icon="far fa-user"
							value={this.state.email}
						    component={this.renderField}
						/>

						<Field
								name="password"
								type="password"
								placeholder="Password"
								className="form-control"
								icon="fas fa-lock"
								value={this.state.password}
								component={this.renderField}
						/>

						<button type="submit" className="btn btn-lg btn-primary full-width">Login</button>
					</form>
					<div className="text-center small mt-10">
						<Link to={`/${this.state.bname}/forgot_password`}>Forgot your password?</Link>
					</div>
					<div className='divider'>
  						<span className='divider-text'>Or</span>
					</div>
                    <div className="text-center small mt-10">
                        <Link className='btn btn-lg btn-default full-width' to={`/${this.state.bname}/sign_up`}>Sign up as member</Link>
                    </div>
					<div className="text-center small mt-10">
						<Link to={`/${this.state.bname}/forgot_password`}>Already a member?</Link>
					</div>
				</div>
			</div>
		);
	}
}

function validate(values) {
	let errors = {};

	if(!values.email)
		errors.email = 'Please enter an email';
	if(!values.password)
		errors.password = 'Please enter a password';

	return errors;
}

export default reduxForm({validate: validate, form: 'loginForm'})(connect(null, { login })(Login));
